/**
 * Route for `new-fallback-redirect-attribution`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { NewFallbackRedirectAttributionPage } from "../features/new-fallback-redirect-attribution/NewFallbackRedirectAttributionPage";

export const newFallbackRedirectAttributionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/new-fallback-redirect-attribution",
	component: NewFallbackRedirectAttributionPage,
});

export default newFallbackRedirectAttributionRoute;
